import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
// Neemt bij het laden een momentopname van het webadres, vóór de router het opschoont.
import "./lib/auth-callback";
// Zet de vertaalmachine klaar; de taal komt uit de URL.
import "./i18n";
import { routeTree } from "./routeTree.gen";
import { dehydratePublicQueries, hydrateSerializedPublicQueries } from "./lib/public-query-cache";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    defaultPreloadStaleTime: 0,
    dehydrate: () => ({ publicQueries: JSON.stringify(dehydratePublicQueries(queryClient)) }),
    hydrate: (state) => hydrateSerializedPublicQueries(queryClient, state.publicQueries),
  });

  return router;
};
